import { getToken, getRefreshToken } from "@saas/server-api/src/plugins/auth";
export function jsToFlutter(action, params, otherData = {}) {
  if (window.JsToFlutter) {
    let data = {
      action,
      params: params || {},
      ...otherData,
    };
    switch (action) {
      case "login":
        break;
      case "getToken":
        break;
      case "refreshToken":
        data.params = {
          accessToken: getToken(),
          refreshToken: getRefreshToken(),
        };
        break;
      case "joinLiveRoom":
        if (location.hostname === "web.zhixinoj.com") {
          data.params = {
            ...data.params,
            scene: "alpha",
          };
        }
        break;
      case "wxpay":
        break;
    }
    console.log(data, "JsToFlutter====");
    window.JsToFlutter?.postMessage(JSON.stringify(data));
  }
}

export const flutterBridge = {
  testfn: (action, params) => {
    return new Promise((resolve) => {
      const callbackName = "callback_" + action;
      window[callbackName] = (result) => {
        resolve(result);
        delete window[callbackName];
      };
      window.JsToFlutter?.postMessage(
        JSON.stringify({
          action,
          params: {
            ...params,
            callbackName: callbackName,
          },
        })
      );
    });
  },
};
